<template>
  <div>
    Reset Password
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
